import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Outlet, useParams, useRouteLoaderData } from '@rocketlane/rocket-router';
import styled from 'styled-components';
import { ProjectResourceOrUndefined } from 'hooks/rbac/useWithAccess';
import { SwitchContentBasedOnAccess } from 'hooks/rbac/withAccess';
import { getProjectPlanUrl, getProjectTasksUrl } from 'utils/urls';
import { RouteIds } from './routes-paths';
export const Fallback = ()=>{
    // eslint-disable-next-line @calm/react-intl/missing-formatted-message
    return /*#__PURE__*/ _jsx("p", {
        children: "Performing initial data load"
    });
};
/** Renders auth routes above `#rl-boot-skeleton` (z-index 9999) without dismissing it. */ const AuthRoutesLayer = styled.div`
  position: relative;
  z-index: 10000;
  min-height: 100vh;
  min-height: 100dvh;
`;
export const NonProtectedRoutesLayout = ()=>{
    return /*#__PURE__*/ _jsx(AuthRoutesLayer, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
};
export const ProjectDetailRouteNavigator = ()=>{
    const { projectId: _projectId } = useParams();
    const projectData = useRouteLoaderData(RouteIds.projectDetailRoute);
    const projectAsResource = ProjectResourceOrUndefined(projectData);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(SwitchContentBasedOnAccess, {
            rule: "PROJECT:READ",
            resourceData: projectAsResource,
            hasAccess: /*#__PURE__*/ _jsx(Navigate, {
                replace: true,
                to: getProjectPlanUrl([
                    'project_id',
                    Number(projectData === null || projectData === void 0 ? void 0 : projectData.projectId)
                ])
            }),
            doesNotHaveAccess: /*#__PURE__*/ _jsx(Navigate, {
                replace: true,
                to: getProjectTasksUrl([
                    'project_id',
                    Number(projectData === null || projectData === void 0 ? void 0 : projectData.projectId)
                ])
            })
        })
    });
};
export const DashboardWidgetWrapper = ()=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
};
